import React from "react"
import ReactDOM from "react-dom/client"
import isBetween from "dayjs/plugin/isBetween"
import isLeapYear from "dayjs/plugin/isLeapYear"
import relativeTime from "dayjs/plugin/relativeTime"
import duration from "dayjs/plugin/duration"
import "./index.scss"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { setScreenInfo } from "./utils/css"
import initECharts from "@/initECharts"
import dayjs from "dayjs"
import { workStore } from "./store"
import { killConsole } from "@/utils"
import { AliveScope } from "react-activation"

import "./intl"

dayjs.extend(duration)
dayjs.extend(isBetween)
dayjs.extend(isLeapYear)
dayjs.extend(relativeTime)

setScreenInfo()
initECharts()
workStore.initStore()

window.addEventListener("resize", setScreenInfo)

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
    <AliveScope>
        <App />
    </AliveScope>,
)

reportWebVitals()
if (process.env.REACT_APP_ENV === "PROD") {
    killConsole()
} else {
    document.title = "色站-后台"
}
